import { HttpInterceptor, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AlertService } from '../_services/alert.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/alert.service";
var HttpErrorInterceptorService = /** @class */ (function () {
    function HttpErrorInterceptorService(alertService) {
        this.alertService = alertService;
    }
    HttpErrorInterceptorService.prototype.handleError = function (error) {
        if (this.alertService)
            this.alertService.error("http error " + error.message);
        else
            alert(error.message);
        return throwError(error);
    };
    HttpErrorInterceptorService.prototype.intercept = function (req, next) {
        return next.handle(req)
            .pipe(retry(0), catchError(this.handleError));
    };
    ;
    HttpErrorInterceptorService.ngInjectableDef = i0.defineInjectable({ factory: function HttpErrorInterceptorService_Factory() { return new HttpErrorInterceptorService(i0.inject(i1.AlertService)); }, token: HttpErrorInterceptorService, providedIn: "root" });
    return HttpErrorInterceptorService;
}());
export { HttpErrorInterceptorService };
